module.exports = __webpack_public_path__ + "aaf71ca0115c6b9331c1a9ed9fb800f1.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular-Oblique.ttf
// module id = 385
// module chunks = 0